import { render, staticRenderFns } from "./SaleFormSuccess.vue?vue&type=template&id=57816804&scoped=true&lang=pug"
var script = {}
import style0 from "./SaleFormSuccess.vue?vue&type=style&index=0&id=57816804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57816804",
  null
  
)

export default component.exports